<!-- BOM物料 -->
<template>
  <BaseFormItem
    class="buy_bom"
    :label="fields.label"
    :isShowLabelTitle="false"
    :labelTips="tips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <!-- BOM文件、坐标文件上传 -->
    <div v-show="[1, 2, 4].includes(buyBom)" class="buy_bom__upload">
      <div class="buy_bom__upload__list">
        <div class="buy_bom__upload__item">
          <UploadAndAnalyzeNew
            ref="bomUploadRef"
            type="bom"
            :accept="getUploadAccept('bom')"
            :fileUrl="bomFile.url"
            :fileName="bomFile.name"
            :tips="tips"
            :bomId="bomId"
            :pcbFileAnalyzeStatus="pcbFileAnalyzeStatus"
            :analyzeFile="analyzeFile"
            @change="handleBomFileChange"
            @beforeLogin="() => $emit('beforeLogin')"
            @downloadTemplateUrl="downloadTemplateUrl"
          />
        </div>
      </div>
    </div>
  </BaseFormItem>
</template>

<script>
import UploadAndAnalyzeNew from '../components/uploadAndAnalyzeNew'

import { getSMTFields } from '@@/utils/getFields'
import { bomSmtTemplateDownload } from '@@/api/pcba'
import {  isMyCenterSite } from '@@/utils/is'

export default {
  props: {
    value: {
      type: [String, Number],
      default: 1
    },
    bomFile: {
      type: Object,
      default: () => ({})
    },
    // BOM选型id
    bomId: {
      type: [String, Number],
      default: ''
    },
    customPcbBan: {
      type: Number,
      default: 1
    },
     // 是否正在从PCB解析坐标文件
    pcbFileAnalyzeStatus: {
      type: Number,
      default: 0
    },
    analyzeFile: {
      type: String,
      default: ''
    },
    // 添加buy_bom值，用于判断是否需要显示上传区域
    buyBom: {
      type: [String, Number],
      default: 1
    }
  },
  components: {
    UploadAndAnalyzeNew,
  },
  data() {
    return {
      val: this.value || 1,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('bom_file')
    },
    tips(){
      return '.xls、.xlsx、.csv、.txt格式 (50M以内)'
    },
  },
  methods: {
    getUploadAccept(type) {
      // coord 坐标文件 bom BOM文件
      if(isMyCenterSite) {
        return '*'
      }
      if(type === 'coord') {
        return this.canUploadZip ? '.zip,.rar,.xls,.xlsx,.csv,.txt' : '.xls,.xlsx,.csv,.txt'
      }
      // bom默认就是组件内部支持格式所以返回undefined就行
    },
    // BOM、SMT模板下载
    downloadTemplateUrl(downloadType) {
      bomSmtTemplateDownload({ downloadType })
        .then(res => {
          if (!res) return
          const { retCode, result } = res
          if (retCode === 0) {
            window.open(result)
          }
        })
    },
    // BOM文件上传成功
    handleBomFileChange(data) {
      this.$emit('bomFileChange', data)
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    },
    setFile(data) {
      this.$refs['bomUploadRef'].setFile(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.buy_bom__upload__item_banner{
  font-size: 12px;
  color: #999999;
  display: inline-flex;
  align-items: center;
  font-weight: normal;
  margin-left: auto;
  float: right;
}
.buy_bom__upload__item_fail{
  color:#FF4D4F;
}
.buy_bom__upload__item_warning{
  color:#E6A23C;
}
.buy_bom__upload__item__analyzing{
  .icon-loading{
    width: 16px;
    height: 16px;
    margin-right: 4px;
    background: url("~@@/assets/img/icons/loading-gif.svg") no-repeat no-repeat center;
    background-size: contain;
  }
}

.buy_bom {
  .buy_bom__upload {
    position: relative;
    box-sizing: border-box;
    width: 630px;
    // margin-top: 5px;
    // padding: 12px 18px;
    border-radius: $--border-radius-base;
    // border: 1px dashed $--form-color-base;
    // background-color: $--background-base;
  }
}
</style>